import React, {Fragment} from 'react';
import {Formatted, Video, Quote} from 'components';
import {config} from 'helpers';

export function Habits() {
  return (
    <Fragment>
      <Formatted className="medium-spacing">
        <Video.Video src={config.videos.identity.habits} />
        <div className="medium-spacing">
          <p>A habit is something you do without really thinking about it.</p>
          <p>There are good habits, like brushing your teeth before bed or stretching before running, and bad habits, like leaving things until the last minute or always arriving late. Good habits support you in living the life you want and bad habits usually undermine what you′re working for. The thing about bad habits is that we often confuse them with character traits and accept them as fact, when really they′re just habits. And habits can be changed.</p>
          <p>In this section of { config.appName } we′ll look at your life habits; the ones that support you and the ones that don′t. The thing about habits, both good and bad, is that they generally serve you in some way. For example, leaving work until the last minute may be a good excuse for not doing your best job. Or, maybe you always arrive late because it is uncomfortable to be in public alone, so the habit is really protecting you from an uncomfortable situation. But at the same time it could be hurting your friend′s feelings or making your boss unhappy. Understanding where these habits come from and what motivates them can help you change your behavior.</p>
        </div>
      </Formatted>
      <Quote author="Rob Gilbert">
        First we form habits, then they form us. Conquer your bad habits or they will conquer you.
      </Quote>
    </Fragment>
  );
}
